import React from 'react'

export const NothingSelected = () => {
    return (
        <div className="nothing__main-content">
            <p>
                Select something
                <br />
                pr create an entry!
            </p>

            <i className="far fa-star fa-4x mt-5"></i>

        </div>
    )
}
